import { render, staticRenderFns } from "./Policy-items.vue?vue&type=template&id=09363994&scoped=true&"
import script from "./Policy-items.vue?vue&type=script&lang=js&"
export * from "./Policy-items.vue?vue&type=script&lang=js&"
import style0 from "./Policy-items.vue?vue&type=style&index=0&id=09363994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09363994",
  null
  
)

export default component.exports